
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Urbaniaonrentinpiprichichwad() {



  const cardData =
  {
    keyword: ' Urbania on Rent in Pimpri Chinchwad',
    heading: 'Vaishnavi Travels: Urbania on Rent in Pimpri Chinchwad',
    headingDescription: 'Vaishnavi Travels provides affordable and reliable Urbania on Rent in Pimpri Chinchwad, perfect for family trips, weddings, corporate outings, school tours, and outstation journeys. Our Urbania vehicles are well-maintained with spacious push-back seating, modern interiors, powerful air-conditioning, and ample luggage space to ensure a smooth and enjoyable travel experience. With professional drivers, punctual service, and flexible booking options, we make group travel stress-free and convenient. Whether it’s a religious yatra, weekend picnic, or business tour, Vaishnavi Travels guarantees safe, comfortable, and dependable Urbania rental services in Pimpri Chinchwad.',

    top: 'Top Places to Visit in Pune with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort palace and a proud symbol of Maratha power. Once the seat of the Maratha Empire, its massive gates, sprawling gardens, and ruins narrate tales of valor. Though partially destroyed by a fire in 1828, it still draws thousands of visitors every day. The evening light-and-sound show brings alive the love story of Bajirao and Mastani and the grandeur of the Peshwas. Its corridors, courtyards, and fountains carry echoes of Maratha history. Shaniwar Wada remains Pune’s most cherished cultural landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Built in 1892, the Aga Khan Palace is one of Pune’s most historic monuments linked to India’s freedom struggle. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. Today, the palace houses a museum displaying Gandhi’s personal belongings, letters, and photographs. Its Italian arches and sprawling gardens add architectural charm and peaceful vibes. Tourists enjoy strolling through its lawns while reflecting on history. Aga Khan Palace is Pune’s inspirational symbol of patriotism and sacrifice."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is a legendary hill fort known for the 1670 battle where Tanaji Malusare fought valiantly for Chhatrapati Shivaji Maharaj. Perched atop a hill, it offers breathtaking panoramic views of the Sahyadris and trekking trails loved by adventurers. The fort still houses bastions, memorials, and temples that narrate Maratha bravery. During monsoon, mist and waterfalls enhance its charm. Visitors also relish rustic delicacies like pithla-bhakri at local stalls. Sinhagad Fort is Pune’s perfect blend of history, nature, and adventure."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. Established over 125 years ago, it houses a magnificent idol adorned with gold and ornaments. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities attracting lakhs of devotees. Known for its charitable and cultural initiatives, it serves as both a spiritual and social hub. The temple’s vibrant aura captivates tourists and locals alike. Dagdusheth Ganpati Temple is Pune’s divine and cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "The Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. It features massive stone pillars, sanctum chambers, and a Nandi mandapa. Despite being in the city center, it offers peace and meditation amidst the chaos. Evening prayers and chants add to its mystical ambiance. The temple reflects ancient Indian craftsmanship and architectural skill. Pataleshwar Cave Temple is Pune’s hidden gem of spiritual heritage."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum is a cultural treasure housing over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include musical instruments, ornaments, sculptures, and everyday antiques. A highlight is the recreated Mastani Mahal, reflecting the romance of Maratha history. Students and history enthusiasts find it deeply educational and fascinating. The museum preserves centuries of traditions and artistry under one roof. Raja Dinkar Kelkar Museum is Pune’s proud showcase of culture and heritage."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest heritage landmarks, offers panoramic views of the city from its temple complex. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller temples and a museum add depth to the visit. Pilgrims and tourists climb 103 steps to reach the top, combining devotion with scenic beauty. Sunrise and sunset views from here are mesmerizing. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global hub for wellness, spirituality, and mindfulness. Spread across lush gardens, it attracts seekers and tourists from all over the world. The ashram offers meditation sessions, yoga practices, and personal growth workshops. Its Japanese Zen gardens and tranquil halls enhance the experience. Beyond spirituality, it is also a retreat for relaxation and rejuvenation. Osho Ashram is Pune’s international center of peace and healing."
  },
  {
    "title": "Pu La Deshpande Garden (Okayama Friendship Garden)",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. With flowing streams, stone bridges, and manicured lawns, it is a paradise for nature lovers. Families enjoy picnics, photography, and peaceful walks here. The garden symbolizes Indo-Japanese friendship and cultural exchange. Seasonal flowers add color and charm throughout the year. Pu La Deshpande Garden is Pune’s green paradise of calm and beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is Pune’s popular weekend getaway. It supplies water to the city while offering scenic backdrops of hills and flowing waters. During monsoon, the overflowing dam creates spectacular views. Families enjoy roadside snacks like roasted corn and tea by the banks. It also serves as the gateway to Sinhagad Fort nearby. Khadakwasla Dam is Pune’s refreshing natural retreat for relaxation and leisure."
  }
],


  "services": [
    {
      "name": "Urbania Van Hire PCMC",
      "description": "Rent a spacious and comfortable Urbania van in Pimpri Chinchwad (PCMC) for all your travel needs. Perfect for family outings, corporate events, or local tours, our Urbania vans offer reliable transportation with flexible seating options including 13 and 17 seaters. Equipped with AC and Non-AC variants, these vans ensure a smooth, safe, and enjoyable ride around PCMC and beyond."
    },
    {
      "name": "Force Urbania Rental Pimpri",
      "description": "Book the powerful Force Urbania van in Pimpri for a durable and stylish travel experience. Designed to handle Indian roads with ease, this van is ideal for school trips, wedding transport, and group travel. Features include comfortable seating, ample luggage space, tinted windows, and well-maintained interiors to guarantee a hassle-free journey."
    },
    {
      "name": "13/17 Seater Urbania Pimpri Chinchwad",
      "description": "Choose from our 13 or 17 seater Urbania vans in Pimpri Chinchwad for efficient group travel. Whether it's a small family trip or a corporate outing, these vans provide spacious interiors, ergonomic seating, and advanced safety features. Perfect for city rides or outstation tours with experienced drivers included."
    },
    {
      "name": "AC Urbania on Rent PCMC",
      "description": "Experience cool and comfortable travel with our air-conditioned Urbania vans available on rent in PCMC. These AC vans are equipped with efficient cooling systems, plush seating, and modern amenities to keep passengers refreshed during city commutes or long-distance travel."
    },
    {
      "name": "Corporate Urbania PCMC",
      "description": "Professional Urbania van rentals in PCMC tailored for corporate clients. Ideal for employee shuttles, client transport, and business meetings. Vans come with clean interiors, punctual drivers, and options for branding. Flexible rental packages for daily, weekly, or monthly use."
    },
    {
      "name": "Wedding Urbania Hire Pimpri",
      "description": "Make your wedding transport seamless with our dedicated Urbania van hire services in Pimpri. Available for guest transfers, VIP movement, and family travel during weddings, these vans offer timely service, optional decoration, and a comfortable ride for your special day."
    },
    {
      "name": "Urbania Outstation Travel PCMC",
      "description": "Plan hassle-free outstation trips from PCMC with our Urbania van rentals. Whether heading to hill stations, pilgrimage sites, or weekend getaways, our vans provide ample space, reclining seats, luggage compartments, and professional drivers for a smooth journey."
    },
    {
      "name": "Urbania Booking Near Me Pimpri",
      "description": "Convenient Urbania van booking near you in Pimpri Chinchwad. Easy online reservation, doorstep pick-up, and transparent pricing. All vans come with safety checks, regular sanitization, and courteous drivers for worry-free travel."
    },
    {
      "name": "Urbania Van with Driver PCMC",
      "description": "Hire Urbania vans with experienced and licensed drivers included. Drivers are familiar with PCMC and surrounding areas, ensuring timely pickups and smooth routes for all occasions—weddings, tours, corporate events, and more."
    },
    {
      "name": "Event Urbania Rental PCMC",
      "description": "Perfect Urbania vans for event transport in PCMC. Whether it's a birthday, cultural function, or corporate party, our vans provide reliable, stylish, and spacious travel solutions with driver support and flexible rental durations."
    },
    {
      "name": "Luxury Urbania for Family Travel",
      "description": "Enjoy premium travel with our luxury Urbania vans featuring leather interiors, enhanced legroom, ambient lighting, and advanced climate control. Ideal for family trips, VIP transport, and exclusive tours around PCMC and beyond."
    },
    {
      "name": "Urbania Weekend Trip PCMC",
      "description": "Book our Urbania vans for weekend getaways from PCMC. Whether it’s a group of friends or family, travel comfortably to destinations like Lonavala, Matheran, or Alibaug. Flexible booking options with inclusive fuel and toll packages."
    },
    {
      "name": "Tour Urbania Hire in Chinchwad",
      "description": "Explore Chinchwad and nearby tourist spots with our Urbania tour van rentals. Spacious seating, panoramic windows, and friendly drivers make sightseeing tours, heritage visits, and cultural excursions hassle-free and enjoyable."
    }
  ],
  "tableData": [
    ["Urbania Van Hire PCMC", "Force Urbania Rental Pimpri"],
    ["13/17 Seater Urbania Pimpri Chinchwad", "AC Urbania on Rent PCMC"],
    ["Corporate Urbania PCMC", "Wedding Urbania Hire Pimpri"],
    ["Urbania Outstation Travel PCMC", "Urbania Booking Near Me Pimpri"],
    ["Urbania Van with Driver PCMC", "Event Urbania Rental PCMC"],
    ["Luxury Urbania for Family Travel", "Urbania Weekend Trip PCMC"],
    ["Tour Urbania Hire in Chinchwad"]
  ],




"whychoose": [
  {
    "WhyChooseheading": "Urbania on Rent in Pimpri Chinchwad",
    "WhyChoosedescription": "Vaishnavi Travels offers premium Force Urbania vans for rent in Pimpri Chinchwad, perfect for luxury travel, business needs, and outstation trips."
  },
  {
    "WhyChooseheading": "Comfortable and Modern Interiors",
    "WhyChoosedescription": "Our Urbania fleet features spacious seating, air conditioning, mood lighting, and high-quality interiors for a smooth and stylish ride."
  },
  {
    "WhyChooseheading": "Sanitized and Well-Maintained Vehicles",
    "WhyChoosedescription": "Each Urbania is thoroughly cleaned and serviced before every trip to ensure hygiene, safety, and reliability."
  },
  {
    "WhyChooseheading": "Flexible Rentals for Every Occasion",
    "WhyChoosedescription": "Available for hourly, daily, and multi-day rentals — ideal for family outings, weddings, corporate transfers, and leisure travel."
  },
  {
    "WhyChooseheading": "Experienced Chauffeurs with Route Knowledge",
    "WhyChoosedescription": "Our drivers are courteous, punctual, and familiar with routes in Pimpri Chinchwad and surrounding areas."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Fees",
    "WhyChoosedescription": "Enjoy fixed, all-inclusive pricing that covers fuel, tolls, taxes, and driver allowance — no surprises at the end of the trip."
  },
  {
    "WhyChooseheading": "Ideal for Executive, Group, and VIP Travel",
    "WhyChoosedescription": "Force Urbania is the perfect choice for VIP guest transport, corporate teams, or premium group travel requirements."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Our dedicated support team is available round-the-clock to assist with bookings, route planning, and any changes."
  }
]



















  }






const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels offer 13 seater Force Urbania on rent in Pimpri Chinchwad?',
      answer: 'Yes, Vaishnavi Travels provides 13 seater Force Urbania vehicles on rent in Pimpri Chinchwad, perfect for small group travel, corporate transfers, and family outings in the PCMC area.',
    },
    {
      question: 'What are the key features of the 13 seater Force Urbania available in Pimpri Chinchwad?',
      answer: 'The 13 seater Force Urbania comes with spacious seating, air-conditioning, comfortable legroom, modern interiors, and ample luggage space to ensure a comfortable ride.',
    },
    {
      question: 'Are the Force Urbania vehicles well-maintained and driven by professionals?',
      answer: 'Absolutely! All vehicles are regularly serviced and maintained. Rentals include experienced and courteous drivers familiar with Pimpri Chinchwad and surrounding routes.',
    },
    {
      question: 'What is the approximate rental cost for a 13 seater Force Urbania in Pimpri Chinchwad?',
      answer: 'Rental costs generally start around ₹3,500 for local half-day trips. Pricing varies depending on duration, distance, and any additional services requested.',
    },
    {
      question: 'Can I book the 13 seater Force Urbania for outstation trips from Pimpri Chinchwad?',
      answer: 'Yes, we offer outstation packages for day trips and multi-day journeys outside Pimpri Chinchwad with clear and transparent pricing.',
    },
    {
      question: 'How far in advance should I book a 13 seater Force Urbania in Pimpri Chinchwad?',
      answer: 'It is advisable to book at least 2-3 days ahead, especially during weekends and peak travel seasons to secure your booking.',
    },
    {
      question: 'Is flexible pickup and drop-off available in Pimpri Chinchwad?',
      answer: 'Yes, we provide flexible pickup and drop locations within Pimpri Chinchwad and nearby areas to best suit your travel plans.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Rohit Deshpande",
    position: "IT Consultant",
    feedback:
      "We booked a 13 seater Force Urbania from Vaishnavi Travels in Pimpri Chinchwad for a corporate trip. The vehicle was clean, air-conditioned, and comfortable. The driver was very professional and punctual. Great service overall!",
    rating: 5,
  },
  {
    name: "Ms. Sneha Joshi",
    position: "Event Coordinator",
    feedback:
      "The 13 seater Urbania was ideal for our family outing in Pimpri Chinchwad. Spacious seating and smooth ride made our trip enjoyable. The team at Vaishnavi Travels was very supportive and professional.",
    rating: 5,
    style: "style-2",
  }
];
































































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania on Rent in Pimpri Chinchwad",
  "image": "https://vaishnavitravel.com/assets/images/urbania-on-rent-pimpri-chinchwad.jpg",
  "description": "Book Force Urbania on rent in Pimpri Chinchwad (PCMC) with Vaishnavi Travels. Available in 13 and 17 seater AC options for corporate events, weddings, outstation trips, and weekend tours with driver.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.87",
    "ratingCount": "470"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4200",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/urbania-on-rent-in-pimpri-chinchwad"
  }
};



  return (
    <div>


<Helmet>
  <title>Urbania on Rent in Pimpri Chinchwad | 13 & 17 Seater AC Vans | Vaishnavi Travels</title>
  <meta
    name="description"
    content="Book Force Urbania on rent in Pimpri Chinchwad (PCMC) with Vaishnavi Travels. Available in 13 and 17 seater AC options for corporate events, weddings, outstation trips, and weekend tours with driver."
  />
  <meta
    name="keywords"
    content="Urbania Van Hire PCMC, Force Urbania Rental Pimpri, 13/17 Seater Urbania Pimpri Chinchwad, AC Urbania on Rent PCMC, Corporate Urbania PCMC, Wedding Urbania Hire Pimpri, Urbania Outstation Travel PCMC, Urbania Booking Near Me Pimpri, Urbania Van with Driver PCMC, Event Urbania Rental PCMC, Luxury Urbania for Family Travel, Urbania Weekend Trip PCMC, Tour Urbania Hire in Chinchwad"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/38.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Urbaniaonrentinpiprichichwad;